var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("Información del asiento")]),_c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-body align-items-center text-center"},[(!_vm.information)?_c('p',{staticClass:"mb-0"},[_vm._v("Mueva el mouse sobre el asiento para ver mas información.")]):_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.information))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }